const state = {
  designer: {},
  commissions: [],
  banking: {},
  paid_requests: []
};

const getters = {

  designer(state) {
    return state.designer || {};
  },
  commissions(state) {
    return state.commissions || [];
  },
  banking(state) {
    return state.banking || {};
  },
  paid_requests(state) {
    return state.paid_requests || [];
  }
};

const actions = {
  async get({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('designer/get')
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async getBanking({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('banking/setupDesigner')
        .then((response) => {
          commit('SET_BANKING', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async add({ commit }, isKpop) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`designer/add?isKpop=${isKpop}`)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async updateDetails({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('designer/updateDetails', payload)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async uploadProfileImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$api
        .post(`designer/uploadProfileImage?isFeatured=${req.isFeatured}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async setEnablePayments({ commit }, value) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`designer/setEnablePayments?value=${value}`)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('designer/saveCategory', payload)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data.categories.find(x => x.category.id === payload.category.id));
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async addCategoryFiles({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      for (var file of req.files) {
        formData.append('file', file);
      }
      this._vm.$api
        .post(`designer/addCategoryFiles?categoryId=${req.categoryId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async setCategoryFileFavorite({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`designer/setCategoryFileFavorite?categoryId=${req.categoryId}&imageId=${req.imageId}&value=${req.value}`)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async deleteCategoryFile({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .delete(`designer/deleteCategoryFile?id=${id}`)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveLink({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('designer/saveLink', payload)
        .then((response) => {
          commit('SET_DESIGNER', response.data);
          resolve(response.data.links);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async getCommissions({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('designer/getCommissions')
        .then((response) => {
          commit('SET_COMMISSIONS', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async getPaidRequests({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('designer/getPaidRequests')
        .then((response) => {
          commit('SET_PAID_REQUESTS', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const mutations = {

  SET_DESIGNER(state, payload) {
    state.designer = payload || {};
  },
  SET_COMMISSIONS(state, payload) {
    state.commissions = payload || [];
  },
  SET_BANKING(state, payload) {
    state.banking = payload || [];
  },
  SET_PAID_REQUESTS(state, list) {
    state.paid_requests = list || [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
